<ion-header>
  <ion-row class="ion-align-items-center">
    <div class="column">
      <div class="back" (click)="back()">
        <img src="assets/icon/back.svg" alt="" />
      </div>
      <div class="logo">
        @if (isAdd) {
          <span>{{'replace_product.add_title' | translate}}</span>
        }
        @if (!isAdd) {
          <span>{{'replace_product.replace_title' | translate}}</span>
        }
      </div>
    </div>
  </ion-row>
</ion-header>

<ion-content>
  <ion-row class="search-wrap ion-justify-content-between ion-align-items-center">
    @if (!isSearch) {
      <div>
        <h2>{{'fridge.section'| translate}} <span>#{{ activeSection.number }}</span></h2>
        <div class="fridge-info">
          {{'fridge.rack'| translate}} #{{ rackNumber }}, {{'fridge.shelf'| translate}} #{{
          activeShelf.number }}, {{'fridge.fridge'| translate}} #{{
          fridgeService.activeFridge.inventoryNumber }}
        </div>
      </div>
    }
    <app-search-wrap
      class="search"
      (close)="closeSearch()"
      (onSearch)="search($event)"
      title=""
    ></app-search-wrap>
  </ion-row>

  @if (productService.paginatedImagesLinks && productService.paginatedProducts && !isSearch) {
    <div
      class="products"
      >
      @for (product of productService.paginatedProducts; track product._id) {
        <app-replace-product-view
          [product]="product"
          [isAdd]="isAdd"
          [merchant]="activeMerchant"
      [image]="
        product.images && productService.paginatedImagesLinks[product.images[0]]
          ? productService.paginatedImagesLinks[product.images[0]].thumbnail
          : ''
      "
          (replace)="replaceProduct(product)"
        ></app-replace-product-view>
      }
    </div>
  }

  @if (isSearch && filteredProducts && filteredProducts.products.length > 0) {
    <div
      class="products"
      >
      @for (product of filteredProducts.products; track product._id) {
        <app-replace-product-view
          [product]="product"
          [isAdd]="isAdd"
          [merchant]="activeMerchant"
      [image]="
        product.images && filteredProducts.imagesLinks[product.images[0]]
          ? filteredProducts.imagesLinks[product.images[0]].thumbnail
          : ''
      "
          (replace)="replaceProduct(product)"
        ></app-replace-product-view>
      }
    </div>
  }

  <ion-infinite-scroll (ionInfinite)="doInfinite()" [disabled]="isSearch">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more data...">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
